import React, { useEffect, useRef } from 'react';
import { Link } from "react-router-dom";
import Typed from 'typed.js';

const IntroThree = () => {
    // Create a ref for the element where the typing animation will be applied
    const el = useRef(null);

    useEffect(() => {
        const options = {
            strings: [
                ' Innovative ',
                ' Intelligent ',
                ' Cost-efficient '
            ],
            typeSpeed: 100,
            backSpeed: 60,
            loop: true,
        };

        // el.current is the mounted span element
        const typed = new Typed(el.current, options);

        // Make sure to destroy Typed instance on unmounting
        // to prevent memory leaks
        return () => {
            typed.destroy();
        };
    }, []);

    return (
        <div className="intro-section section overlay" style={{backgroundImage: `url(/images/banner/Home-page-Image.jpg)`}}>
            <div className="container">
                <div className="row row-cols-lg-1 row-cols-1">
                    <div className="col align-self-center">
                        <div className="intro-content-two headline-active text-center mt-xl-8 mt-lg-8 mt-md-8 mt-sm-8 mt-xs-8">
                            <h2 className="title ah-headline">Building Organizations with <span ref={el} /> IT Solutions</h2>
                            <div className="desc">
                                <p>Tetrahed, Inc. empowers global businesses to thrive by delivering innovative IT services and strategic staffing solutions, helping them navigate the challenges of today and tomorrow.</p>
                            </div>
                            <Link to={process.env.PUBLIC_URL + "/learn-more"} className="btn btn-outline-white btn-hover-primary customBtn1"> Learn More </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default IntroThree;